module.exports = __webpack_public_path__ + "assets/ic_tree22.13df82e5.svg";